<template>
  <div class="primary white--text title mb-5 d-flex">
    <v-btn
      class="orange primary--text font-weight-bold title"
      tile
      height="48px"
      dark
      depressed
    >
      News
    </v-btn>
    <marquee-text :duration="30" class="flex-1 pa-2" :repeat="1">
      {{ news }}
    </marquee-text>
  </div>
</template>

<script>
import MarqueeText from "vue-marquee-text-component";

export default {
  components: {
    MarqueeText,
  },
  computed: {
    news() {
      let { News } = this.$store.getters.dashboard;
      return News ? News : "";
    },
  },
};
</script>

<style>
</style>